module.exports = __webpack_public_path__ + "static/media/internship.698acf64.gif";